import axios from 'axios';

export type GetDictionaryRegistryDataRequestType = {
	fileId: string;
	componentId: string;
	DictionaryId: string;
	Value: string;
	AttrName: string;
};

class DynamicFormAPI {
	/**  */
	static getDictionaryRegistryDataByAttr = async (
		data: GetDictionaryRegistryDataRequestType,
	): Promise<any> => {
		const url =
			window.host + '/DynamicForm/GetDictionaryRegistryDataByAttr';
		try {
			const request = await axios.post(url, data, {
				withCredentials: true,
			});
			return request.data;
		} catch (error: any) {
			throw new Error('Ошибка при получении данных справочника');
		}
	};

	static getDictionaryRegistryData = async (
		partUrl: string,
		formData: FormData,
	): Promise<any> => {
		const url = window.host + partUrl;
		try {
			const request = await axios.post(url, formData, {
				withCredentials: true,
			});
			return request.data;
		} catch (error: any) {
			throw new Error('Ошибка при получении данных справочника');
		}
	};
}

export default DynamicFormAPI;
